import React, { Component } from 'react';
import Config from "../../config";
import Styles from "../../styles/Styles";

const images = require.context('../../assets/images', true);

export default class SecondSection extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <div className="section">
        <h2 style={Styles.Style.bgColorSecondary} className="section-title">L’avantage ne coûte pas, il rapporte</h2>
        <div className="row">
          <div className="mycol-6 presentation">
            <ul>
              <li><b>Une carte appréciée des clients</b></li>
              <li><b>Augmentation de la fréquentation du point de vente</b> (fréquentation sur la parapharmacie : x 2 en moyenne pour les clients encartés)</li>
              <li><b>Augmentation du panier moyen</b></li>
              <li><b>+ 8€ de marge annuelle / client</b>, constaté en moyenne avec les adhérents au programme (effet cumulé de l’augmentation du panier moyen et des passages supplémentaires)</li>
            </ul>
          </div>
          <div className="mycol-6 text-center">
            Panier moyen (remise déduite) {Config.program.graph}
            <img className="image" src={images('./'+Config.program.graph)} alt="Statistiques liées au programme" />
          </div>
        </div>

        <div className="text-center margin-top-l">
          <button style={Styles.Style.bgColorSecondary} className="btn btn-lg btn-primary-primary" onClick={this.props.onButtonClicked}>Moi aussi, je veux améliorer mon chiffre d'affaires</button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/SecondSection.js